module.exports = require('./helpers/bundle-url').getBundleURL('4AlMw') + "mapcamera_red.d229723e.png" + "?" + Date.now();